export function sourceMailBackTarget(returnTo: string | undefined, locationKey: string): string | -1 {
  if (returnTo && /^\/(?!\/)/.test(returnTo)) return returnTo;
  return locationKey === 'default' ? '/events' : -1;
}
